'use client';
import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'next/navigation';
import { POLICIES } from '@/lib/policyData';
import PolicyDetailView from './PolicyDetailView';
import PolicyDetailSkeleton from './PolicyDetailSkeleton';

export default function PolicyDetailClient() {
  const searchParams = useSearchParams();
  const id = searchParams?.get('id') ?? 'policy-star-001';
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate async data load — replace with backend API call
    const timer = setTimeout(() => setLoading(false), 400);
    return () => clearTimeout(timer);
  }, [id]);

  const policy = POLICIES?.find((p) => p?.id === id) ?? POLICIES?.[2];

  if (loading) return <PolicyDetailSkeleton />;

  return <PolicyDetailView policy={policy} />;
}